<template>
  <v-row class="ma-n2 header">
    <CustomButton
      v-if="prevButton"
      class="ml-2 my-auto"
      :level="$enums.ButtonLevels.SmallIcon"
      icon="caret-left"
      @click="$emit('prev')"
    />
    <template v-if="header !== undefined">
      <template v-if="headerEditable">
        <CustomTextInput
          v-model="internalHeader"
          ref="headerInput"
          :plain="true"
          :max="30"
          :class="editingHeader ? '' : 'pointer-events-none'"
          :disabled="headerEditLoading"
          :forcedFocus="editingHeader"
          class="mr-0"
          style="width: calc(100% - 74px)"
          @keyup.enter="saveHeader"
        />
        <CustomButton
          class="ml-auto mr-2 my-auto"
          :level="$enums.ButtonLevels.SmallIcon"
          :icon="
            editingHeader ? 'save' : headerEditLoading ? 'spinner' : 'edit'
          "
          :disabled="headerEditableDisabled || headerEditLoading"
          @click="
            () => {
              if (!editingHeader) startEditingHeader();
              else saveHeader();
            }
          "
        />
      </template>
      <v-col v-else class="pa-0 token-text-regular ml-3 my-auto">
        {{ header }}
      </v-col>
    </template>
    <template v-else-if="displayProgression">
      <v-col class="progression-col pa-0 ma-auto">
        <TabProgression :stage="progression" :maxStage="maxProgression" />
      </v-col>
    </template>

    <CustomButton
      v-if="closeButton"
      class="ml-auto mr-2 my-auto"
      :level="$enums.ButtonLevels.SmallIcon"
      icon="x"
      @click="$emit('close')"
    />
  </v-row>
</template>

<script lang="ts">
import { Vue, Options, prop } from "vue-class-component";
import CustomButton from "@/components/UIElements/CustomButton.vue";
import CustomTextInput from "@/components/UIElements/CustomTextInput.vue";
import TabProgression from "@/components/UIElements/TabProgression.vue";
import Icon from "@/components/UIElements/Icon.vue";

class Props {
  header?: string = prop({
    required: false,
  });
  headerEditable?: boolean = prop({
    required: false,
  });
  headerEditableDisabled?: boolean = prop({
    required: false,
  });
  headerEditCall?: (header: string) => Promise<void> = prop({
    required: false,
  });
  prevButton?: boolean = prop({
    required: false,
  });
  closeButton?: boolean = prop({
    required: false,
  });
  displayProgression?: boolean = prop({
    required: false,
  });
  progression?: number = prop({
    required: false,
  });
  maxProgression?: number = prop({
    required: false,
  });
}

@Options({
  components: {
    CustomButton,
    CustomTextInput,
    TabProgression,
    Icon,
  },
})
export default class MPHDefault extends Vue.with(Props) {
  internalHeader?: string = this.header;
  editingHeader = false;
  headerEditLoading = false;

  startEditingHeader() {
    if (!this.editingHeader) {
      this.editingHeader = true;
      this.$nextTick(() => {
        const input = (this.$refs.headerInput as any)?.$el?.querySelector(
          "input",
        ) as HTMLInputElement | null;
        if (input) {
          input.focus();
        }
      });
    }
  }

  saveHeader() {
    if (
      this.editingHeader &&
      this.header !== this.internalHeader &&
      this.headerEditCall
    ) {
      this.$nextTick(() => {
        const input = (this.$refs.headerInput as any)?.$el?.querySelector(
          "input",
        ) as HTMLInputElement | null;
        if (input) {
          input.blur();
        }
      });
      this.headerEditLoading = true;
      this.headerEditCall(this.internalHeader || "")
        .then(() => {
          this.$emit("update:header", this.internalHeader);
        })
        .finally(() => {
          this.editingHeader = false;
          this.headerEditLoading = false;
        });
    } else {
      this.editingHeader = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/variables";
.header {
  height: 42px !important;
  .progression-col {
    max-width: calc(100% - 48px);
  }
}
</style>
